// jQuery( document ).ready(function() {
//   $(".collapsible").click(function(){
//     $('.collapsible.on').removeClass("on");
//     $(this).toggleClass('on');
//   });
// });
$('.ctm_check').click(function() {
  $('.order_addr .cart_addr').addClass("down");
});
$(".product__accordion").click(function(){	  
  $('.product__accordion details').removeAttr('open');
});
$(".header__inline-menu ul.list-menu > li:nth-child(2) details-disclosure>details ul.header__submenu li details").attr('open', '');

$(function() {                       
  $(".menu-drawer__menu-item").click(function() {
    $('.menu-drawer__menu-item.rotate ').removeClass('rotate');  
    $(this).addClass("rotate");      
  });
});

$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

$(".bcart").click(function() {
  $(".bcart-drawer").addClass("active"); 
  $(".overlay").addClass("active");
  $("body").addClass("overflow");
});

$(".cart__close").click(function() {
  $(".bcart-drawer").removeClass("active");
  $(".overlay").removeClass("active");
  $("body").removeClass("overflow");
});

function openLocation() {
  window.dataLayer = window.dataLayer || [];  
  $(".child-container").hasClass("hide") ? (dataLayer.push({
    event: "gift_finder_step",
    level: 0,
    item_name: ""
  }), $(".child-container").removeClass("hide"), $(".main-container").addClass("active"), $(".main-container").removeClass("height-130"),
                                            $(".main-text").addClass("sm"), $(".sub-text").addClass("sm"), $(".start-search").addClass("hide"), $(".cross-red").removeClass("hide"),
                                            $(".gift-box").addClass("rgt_move"), $(".gift-box").removeClass("width-60"), $(".gift-box-2").removeClass("hide"),$(".gift-box-2").addClass("left-20"),
                                            $(".gift-box-2.sec_img").addClass("left-40"),$(".gift-box").removeClass("left-0"),
                                            $(".child-container").addClass("opening"), $("#choose-recipient").addClass("fadein"), $("#text-recipient").removeClass("hide"),
                                            $("#options-recipient").removeClass("hide")) : (backRecipient = !1, backRelationship = !1, $("#options-recipient .red-border").removeClass("red-border"),
                                                                                            $("#options-recipient .red-bg").removeClass("red-bg"), $("#options-recipient .red-color").removeClass("red-color"), $("#options-recipient .img-red").removeClass("img-red"),
                                                                                            $(".child-container").removeClass("opening"), $(".child-container").removeClass("opening-two"), $("#choose-recipient").removeClass("fadein"),
                                                                                            $("#choose-relationship").removeClass("fadein"), $("#choose-occasion").addClass("hide"), $("#input-relationship").addClass("hide"),
                                                                                            $("#choose-relationship").addClass("hide"), $("#input-recipient").addClass("hide"), $("#input-container").addClass("hide"), $("#text-recipient").addClass("hide"),
                                                                                            $("#options-recipient").addClass("hide"), $(".child-container").addClass("hide"), $(".main-container").removeClass("active"), $(".main-container").addClass("height-130"),
                                                                                            $(".main-text").removeClass("sm"), $(".sub-text").removeClass("sm"), $(".start-search").removeClass("hide"), $(".cross-red").addClass("hide"),
                                                                                            $(".gift-box").removeClass("rgt_move"),$(".gift-box").addClass("left-0") , $(".gift-box").addClass("width-60"), $(".gift-box-2").addClass("hide"), $(".gift-box-2").removeClass("left-20"), $("#arrow-recipient").addClass("hide"))
}

function hideRecipient() {
  if (!backRecipient) return !1;
  $("#input-container").removeClass("double-border"), $("#text-recipient").addClass("hide"),
    $("#options-recipient").addClass("hide"), $("#input-recipient").removeClass("hide"), $("#arrow-recipient").addClass("hide")
}

function openSweetnav() {
  $("#myNav").addClass("menu_rgt");
  $("body").addClass("overflow");
}

function closeNav() {
  $("#myNav").removeClass("menu_rgt");
  $("body").removeClass("overflow");
}


$('#loc_frm .code_find').click(function() {
  var ppin = $('#loc_frm input[type="text"]').val();
  $('.fancybox-close-small').trigger("click");
});




function growDiv(e) {
  var growDiv =  e.parentNode.querySelector('.tab_cnt');
  e.parentNode.classList.remove("on");
  if (growDiv.clientHeight) {
    growDiv.style.height = 0;
  } else {
    var wrapper = e.parentNode.querySelector('.tab_inner');
    growDiv.style.height = wrapper.clientHeight + "px";
    e.parentNode.classList.add("on");
  }
}  

   $(document).ready(function(){ 
     $('.same_ship #address_default_address_new').click(function(){ 

     if ($('.same_ship #address_default_address_new').is(":checked")) {      
           
      $('#AddressFirstNameNewB').val($('#AddressFirstNameNew').val());         
      $('#AddressLastNameNewB').val($('#AddressLastNameNew').val());
      $('#AddressCompanyNewB').val($('#AddressCompanyNew').val());
      $('#AddressAddress1NewB').val($('#AddressAddress1New').val());
      $('#AddressAddress2NewB').val($('#AddressAddress2New').val());
      $('#AddressCityNewB').val($('#AddressCityNew').val());

      var country = $('#AddressCountryNew option:selected').val();
      $('#AddressCountryNewB option[value=' + country + ']').attr('selected','selected');

      var state = $('#AddressProvinceNew option:selected').val();
      $('#AddressProvinceNewB option[value=' + country + ']').attr('selected','selected');

      $('#AddressZipNewB').val($('#AddressZipNew').val());
      $('#AddressPhoneNewB').val($('#AddressPhoneNew').val());


     } 
       
     else { 
       
       
         
      $('#AddressFirstNameNewB').val("");
      $('#AddressLastNameNewB').val("");
      $('#AddressCompanyNewB').val("");
      $('#AddressAddress1NewB').val("");
      $('#AddressAddress2NewB').val("");
      $('#AddressCityNewB').val("");
      $('#AddressZipNewB').val("");
      $('#AddressPhoneNewB').val("");
      $('#AddressCountryNewB option[value=""]').attr('selected','selected');
      $('#AddressProvinceNewB option[value=""]').attr('selected','selected');
     };
    });
 
   });



//$(".same_ship #address_default_address_new").prop("checked", true);